import pluralize from 'pluralize';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';
import { useLayoutEffect } from 'react';

const DaysLeftText = observer(({ campaign }) => {
  useLayoutEffect(() => {
    store.campaign.attributes = campaign;
  }, [store.campaign.attributes.daysLeft]);

  const daysLeftText = () => {
    if (store.campaign.attributes.isClosed) {
      return '0 days left';
    } else if (parseInt(store.campaign.attributes.daysLeft) == 0) {
      return 'last day';
    } else {
      return `${store.campaign.attributes.daysLeft} ${pluralize(
        'day',
        parseInt(store.campaign.attributes.daysLeft)
      )} left`;
    }
  };

  return (
    <>
      <p className='text-xs text-grey-60 italic font-medium'>{`${daysLeftText()}${
        isMobile ? ' to give' : ''
      }`}</p>
    </>
  );
});

export default DaysLeftText;
